import { render, staticRenderFns } from "./mapreal.vue?vue&type=template&id=36b053de&scoped=true&"
import script from "./mapreal.vue?vue&type=script&lang=js&"
export * from "./mapreal.vue?vue&type=script&lang=js&"
import style0 from "./mapreal.vue?vue&type=style&index=0&id=36b053de&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b053de",
  null
  
)

export default component.exports